export { setABTestValueDLTag, setDlSubmitWithLabel, getABTestValue };

function setDlSubmitWithLabel(element, label) {
    element.insertAdjacentHTML("afterend","<dl-submit success=" + label + "></dl-submit>");
}

function setABTestValueDLTag(element, testname, value) {
    element.insertAdjacentHTML("afterend", "<dl-pageview ab-test=" + testname + "_" + value + "></dl-pageview>");
}

function getABTestValue() {
    const cookieValue = readABTestCookieValue();
    if (cookieValue) {
        return cookieValue < 5 ? "A" : "B";
    }
}

function readABTestCookieValue() {
    const match = document.cookie.match(new RegExp('(^| )ab_container=([^;]+)'));
    if (match) {
        return match[2];
    }
}